import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const ecwidSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    storeId: z.string().trim().min(1, "Store ID is required"),
    customerGroup: z.string().trim().min(1, "Customer group is required"),
    clientId: z.string().trim().min(1).nullable(),
    createForReturns: z.boolean(),
    createForClaims: z.boolean(),
    createForWarranties: z.boolean(),
    filterByReturnReason: z.boolean(),
    allowedReturnReasons: z
      .array(z.string().trim())
      .transform((reasons) => reasons.filter((reason) => reason.length > 0)),
    overrideSkus: z.boolean(),
    skuOverride: z.string().trim(),
  },
  secrets: {
    accessToken: z.string().trim().min(1, "Access token is required"),
    clientSecret: z.string().trim().min(1).optional(),
  },
  connectOnly: {},
  computed: {},
});

export function ecwidSettingsError(settings: {
  filterByReturnReason: boolean;
  allowedReturnReasons: readonly string[];
  overrideSkus: boolean;
  skuOverride: string;
}): string | null {
  if (settings.filterByReturnReason && !settings.allowedReturnReasons.length) {
    return "At least one return reason is required when return reason filtering is enabled.";
  }
  if (settings.overrideSkus && !settings.skuOverride.trim()) {
    return "An SKU override value is required when SKU override is enabled.";
  }
  return null;
}
